/**
 * Extract initials from a name string.
 *
 * Handles full names ("Jean Dupont" -> "JD"), single words ("Jean" -> "JE"),
 * first/last name pairs, and email addresses ("jean.dupont@acme.com" -> "JD").
 */
export function getInitials(name: string): string {
  if (!name) return '';

  // Email-style input: extract initials from the local part
  if (name.includes('@')) {
    const parts = name.split('@')[0].split('.');
    return parts
      .map((p) => p[0]?.toUpperCase() || '')
      .join('')
      .substring(0, 2);
  }

  const words = name.trim().split(/\s+/);
  if (words.length > 1) {
    return `${words[0][0]}${words[1][0]}`.toUpperCase();
  }
  return name.substring(0, 2).toUpperCase();
}
